import Vue from "vue";
import VueInstagram from "vue-instagram";

Vue.use(VueInstagram);
